import { render, staticRenderFns } from "./rfq-statewide-add-parts.vue?vue&type=template&id=a495f73c&scoped=true"
import script from "./rfq-statewide-add-parts.vue?vue&type=script&lang=js"
export * from "./rfq-statewide-add-parts.vue?vue&type=script&lang=js"
import style0 from "./rfq-statewide-add-parts.vue?vue&type=style&index=0&id=a495f73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a495f73c",
  null
  
)

export default component.exports